import { z } from 'zod'

export const flagExpenseSchema = z.object({
  expenseId: z.string().guid(),
  comment: z.string().max(500).optional(),
})

export type FlagExpenseDto = z.infer<typeof flagExpenseSchema>
